import Vue from "vue";
import { ConstantMeasure, RealtimeMeasure, Alarm, HistoricalMeasure } from "@/models/lib";

const typesEnum = {
    CONSTANT: 0,
    REALTIME: 1,
    ALARM: 2,
    HISTORICAL: 3,
};
/**
 *  Creates checking for basic types (Measurements and Alarms)
 *  inside application 
 */ 
export const typeChecking = Vue.extend({
    data: () => ({
        ...typesEnum
    }),
    methods: {
        isConstant(data) {
            return data instanceof ConstantMeasure;
        },
        isRealtime(data) {
            return data instanceof RealtimeMeasure;
        },
        isAlarm(data) {
            return data instanceof Alarm;
        },
        isHistorical(data) {
            return data instanceof HistoricalMeasure;
        },
        isInstanceOf(data) {
            if (!data) return -1;
            if (this.isConstant(data)) return this.CONSTANT;
            if (this.isRealtime(data)) return this.REALTIME;
            if (this.isAlarm(data)) return this.ALARM;
            if (this.isHistorical(data)) return this.HISTORICAL;
        },
        typeOf(data) {
            const n = this.isInstanceOf(data);
            switch (n) {
            case this.CONSTANT:
                return "constant";
            case this.REALTIME:
                return "realtime";
            case this.ALARM:
                return "alarm";
            case this.HISTORICAL:
                return "historical";
            default:
                return typeof data;
            }
        },

    }
});